module.exports = __webpack_public_path__ + "static/media/cuteFlower.1feb6999.png";